import React from "react";
import { Quotes } from "@phosphor-icons/react";
import { useLandingT } from "@/lib/landingI18n";

const items = [
  { key: "t1" },
  { key: "t2" },
  { key: "t3" },
];

export const TestimonialSection = ({ lang }) => {
  const t = useLandingT(lang);
  return (
    <section className="relative py-20 md:py-28 border-t border-white/8">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="kicker">
            <span className="dot" />
            {t("testKicker")}
          </div>
          <h2 className="h-section mt-5 text-white">{t("testTitle")}</h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {items.map((it) => (
            <div key={it.key} className="glass rounded-2xl p-6 flex flex-col">
              <Quotes
                size={26}
                weight="fill"
                className="text-emerald-400/70 flip-x"
              />
              <p className="mt-4 text-slate-200 text-[15px] leading-relaxed">
                “{t(it.key)}”
              </p>
              <div className="mt-6 pt-5 border-t border-white/8 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-emerald-500/15 border border-emerald-500/30 grid place-items-center text-emerald-300 text-xs font-semibold">
                  {t(`${it.key}Name`).slice(0, 1)}
                </div>
                <div className="min-w-0">
                  <p className="text-white text-sm font-medium">
                    {t(`${it.key}Name`)}
                  </p>
                  <p className="text-slate-500 text-xs">{t(`${it.key}Role`)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
